import axios from 'axios';

import { FLEX_DISCONNECT_REASONS } from 'RestAPIs/endpoints';

export interface FlexDisconnectReasonValues {
  id: number;
  name: string;
  code: string; // Ensure `code` is included here
}

export const getFlexDisconnectReasons = () => {
  return axios.get<FlexDisconnectReasonValues[]>(`${FLEX_DISCONNECT_REASONS}`);
};
